import React, { Component } from "react";
import store from "../store";
import { ROOT } from "../config/config";

class Footer extends Component {
  render() {
    return (
      <footer>
        <p dangerouslySetInnerHTML={{ __html: `pilgrimagekc.com &copy; ${new Date().getFullYear()}` }} />{" "}
        <a href={`${ROOT}TA/privacy`}>Privacy</a>{" "}
        <a href={`${ROOT}TA/about`}>About</a>{" "}
        {parseInt(store.getState().columnOne.details.user_id) > 0 && (
          <a href={`${ROOT}logout`}>Logout</a>
        )}{" "}
      </footer>
    );
  }
}

export default Footer;
